import { form as hikvision } from './profiles/hikvision'
import { form as other } from './profiles/other'

export const profiles = [hikvision, other]
